/* eslint-disable no-plusplus */
export default function toUpgrade (version, lowestVersion) {
    const versionArray = version.split('.');
    const lowestVersionArray = lowestVersion.split('.');

    let needUpgrade = false;

    for (let i = 0; i < lowestVersionArray.length; i++) {
        if (Number(versionArray[i]) > Number(lowestVersionArray[i])) {
            needUpgrade = false;
            break;
        } else if (Number(versionArray[i]) < Number(lowestVersionArray[i])) {
            needUpgrade = true;
            break;
        }
    }
    return needUpgrade;
}